import { bus } from "@/main";
import VueCookies from "vue-cookies";
import { createProjectEntry } from "@/data/models/project.model";
import { getSchoolEntry, updateSchoolEntry } from "@/data/models/school.model";
import { ProjectApplication } from "@/data/classes/project.class";
import { SchoolApplication } from "@/data/classes/school.class";

export default {
	name: "SchoolPage",
	data() {
		return {
			content: null,
			isReadyContent: false,
			projectModal: false,
			schoolModal: false,
			showMore: false,
			projectForm: {
				title: null,
				titleEng: null,
				course: null,
				courseEng: null,
				class: null,
				classEng: null,
			},
			schoolForm: {
				address: null,
				intercolutor: null,
				referenceText: null,
				referenceTextEng: null,
				projects: [],
				logo: [],
			},
			disableKeywords: false,
		}
	},
	created() {
		this.getContent();
		this.user = VueCookies.get("user");
		bus.$on("schoolUpload", (files) => {
			console.log("School Upload", files)
			this.schoolForm.logo = files.images;
			this.submitSchool(true);
		})
	},
	computed: {
		pageUrl: function() {
			return location.href;
		}
	},
	watch: {
		"$route": function () {
			this.getContent();
		}
	},
	methods: {
		getContent() {
			getSchoolEntry(this.$route.params.school, "slug", 2).then(content => {
				this.content = content;
				console.log("School:", content)
				this.isReadyContent = true;
				this.projectForm.schools = [ content ];
				this.schoolForm = content;
			})
		},
		submitProject() {
			this.$validator.validateAll().then((result) => {
				if (result) {
					// eslint-disable-next-line
					createProjectEntry(new ProjectApplication(this.projectForm)).then(response => {
						console.debug("Application creation response:", response);
						if (response.status == 201 ) {
							this.$router.replace({ "hash": "sent" });
							bus.$emit('notification', "📝 Projeto Criado!")
							this.projectModal = false
							this.getContent();
						}
					}).catch(error => {
						this.throwError(error);
					});
				} else {
					console.debug("Form is not valid!");
				}
			});
		},
		submitSchool(open) {
			this.$validator.validateAll().then((result) => {
				if (result) {
					updateSchoolEntry(this.content.id, new SchoolApplication(this.schoolForm), ).then(response => {
						if (response.status == 200) {
							this.$router.replace({ "hash": "sent" });
							bus.$emit('notification', "🏫 Informação sobre a escola Atualizada!")
							open ? this.schoolModal = true : this.schoolModal = false;
						}
					}).catch(error => {
						this.throwError(error);
					});
				} else {
					console.debug("Form is not valid!");
				}
			});
		},
		throwError(error) {
			this.$router.replace({ "hash": "error" });
			alert("😕 An error ocurred. Please send an e-mail to the organization");
			if (error) console.error("Application error:", error);
		},
		modalClose() {
			bus.$emit('modalClose');
		},
		modalOpen() {
			bus.$emit('modalOpen');
		},
		// sendLogo(files) {
			// setTimeout(() => {
			// 	bus.$emit("receivedFiles", files);
			// }, 500);
		// }
	}
}



// WEBPACK FOOTER //
// ./src/components/pages/school/school.page.js